@import '~style-sheet-helpers/core.less';
@import (reference) '../../products/product-details/style.module.less';
@import '../../app-brand/entities/entity-layer.module.less';

.product-auto-complete {
  width: 100%;
  position: relative;
  > input {
    width: 100%;
    .input-border-base-style();
  }
}

.result-dropdown-menu {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid @product-auto-complete--result-dropdown-menu--border-color;
  width: 100%;
  position: absolute;
  bottom: 32px;
  z-index: 2;
}

.row {
  white-space: normal;
}

.item-name {
  font-weight: 500;
  margin-bottom: 5px;
  color: @order-items-list--search-results-row-name--text-color;
}

.item-sku {
  color: @order-items-list--search-results-row-sku--text-color;
}

.item-name,
.item-sku {
  overflow: hidden;
  text-overflow: ellipsis;
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  width: 100%;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-box-orient: vertical;
}

.result-item {
  font-size: 12px;
  border-bottom: 1px solid @order-items-list--search-results-result-item--border-color;

  &:last-child {
    border-bottom: 0;
  }
  // &:hover {
  //   background-color: @product-auto-complete--search-result--hover--background-color;
  // }
}

.icon-common {
  right: 5px;
  top: 0;
  position: absolute;
  height: 100%;
  width: 20px;
  > svg {
    fill: @product-auto-complete--clear-input--fill-color;
    height: 12px;
    width: 12px;
  }
}

.clear-input {
  .icon-common;
  &:hover {
    cursor: pointer;
  }
}

.search-icon {
  .icon-common;
  pointer-events: none;
}
